import { getSupportDisplayPicUrl } from "../../../utilities/conversions";

export default function SidebarModule({ tab, setTab, mobileMenu, setMobileMenu, profile, baseUrl, onLogout }: { tab: string, setTab: (tab: string) => void, mobileMenu: boolean, setMobileMenu: (menu: boolean) => void, profile: any, baseUrl: string, onLogout: () => void }) {
    return (
        <>
            <div className="md:hidden h-14 bg-white border-b border-slate-200 flex items-center justify-between px-4">
                <p className="font-semibold">Dashboard</p>
                <button
                    onClick={() => setMobileMenu(!mobileMenu)}
                    className="w-9 h-9 rounded-full bg-slate-200 overflow-hidden"
                    aria-label="Åpne/lukke meny"
                >
                    <img
                        src={getSupportDisplayPicUrl(profile?.profile_pic, baseUrl)}
                        alt={profile?.name}
                        className="w-full h-full object-cover"
                    />
                </button>
            </div>
            <aside className={`bg-white border-r border-slate-200 flex flex-col w-72 transform md:transform-none md:relative fixed md:static inset-y-0 left-0 z-40 transition-transform duration-300 ${mobileMenu ? "translate-x-0" : "-translate-x-full md:translate-x-0"
                }`}>
                <div className="h-16 px-6 flex items-center border-b border-slate-200">
                    <div className="w-9 h-9 rounded-2xl bg-gradient-to-tr from-indigo-500 to-violet-500 mr-3" />
                    <div>
                        <p className="text-xs uppercase tracking-wide text-slate-400">Chamcore Client</p>
                        <p className="font-semibold">Teletorget AS</p>
                    </div>
                </div>

                <nav className="flex-1 px-3 py-4 space-y-1 text-sm">
                    {[
                        "Dashboard",
                        "Agenter",
                        "Kunder",
                        "Nummer & telefoni",
                        "Ferdigheter",
                        "Rapporter & økonomi",
                        "CMS & innhold",
                        "Kurs & eventer",
                        "Sosiale medier",
                        "Innstillinger",
                        "Logg out",
                    ].map((item, idx) => (
                        <button
                            onClick={() => item === "Logg out" ? onLogout() : setTab(item)}
                            key={item}
                            className={`w-full flex items-center gap-3 px-3 py-2 rounded-xl transition text-left ${item === tab ? "bg-slate-900 text-white shadow-sm" : "text-slate-600 hover:bg-slate-100"
                                }`}
                        >
                            <span className="inline-flex w-7 h-7 rounded-xl bg-slate-100 items-center justify-center text-[11px] font-semibold text-slate-400">
                                {idx + 1}
                            </span>
                            <span className={`truncate ${item === 'Logg out' ? 'text-red-600' : ''}`}>{item}</span>
                        </button>
                    ))}
                </nav>

                <div className="px-4 py-4 border-t border-slate-200 text-xs text-slate-500">
                    <p className="font-medium mb-1">Ditt abonnement</p>
                    <p>Pro • 12 rådgivere inkludert</p>
                </div>
            </aside>
        </>
    );
}